import { luxuryThemeConfig } from './themes/luxury.theme';

/** Dedicated Luxury Club 2.0 build: no tenant switch or demo theme. */
export const activeThemeConfig = luxuryThemeConfig;
